// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__18u4M","subheader":"ReorderModal_subheader__2554_","listWrap":"ReorderModal_listWrap__2dZXn"};